<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="合同列表" v-if="p('enterprisecontract/list')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="合同审核列表" v-if="p('contract/contractAuditList')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="解约协议列表" v-if="p('surrender/surrenderList')">
        <c3></c3>
      </TabPane>
      <TabPane name="4" label="解约协议审核" v-if="p('surrender/surrenderList')">
        <c4></c4>
      </TabPane>
      <TabPane name="5" label="预定单列表" v-if="p('reservation/order/list')">
        <c5></c5>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/contract/contractList/index'
  import C2 from '@/views/contract/auditContract/index'
  import C3 from '@/views/contract/termination/index'
  import C4 from '@/views/contract/auditTermination/index'
  import C5 from '@/views/contract/book/booklist/index'

  import {mixin} from "../../mixin";


  export default {
    name:'invoice',
    components:{
      C1,
      C2,
      C3,
      C4,
      C5
    }        ,
    mixins:[mixin],
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
